<template>
    <component
        :is="$_tag"
        :class="classes"
        :disabled="loading"
        v-bind="attrs"
        v-on="$listeners"
        :title="$_title"
    >
        <slot>
            <template v-if="loading">
                {{loadingText}}
                <oc-icon type="spinner" class="fa-spin" />
            </template>
            <template v-else>
                <oc-icon v-if="iconBefore" :type="iconBefore" v-bind="iconBeforeAttrs" />
                {{text}}
                <oc-icon v-if="icon" :type="icon" v-bind="$_iconAttrs" />
            </template>
        </slot>
    </component>
</template>

<script>
export default {
    name: 'oc-button',
    props: {
        text: [String, Number],
        loading: {
            type: Boolean,
            default: false
        },
        loadingText: {
            type: String,
            default: 'Processing ...'
        },
        type: {
            type: String,
            default: 'default',
            validator: function (value) {
                return ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'default'].indexOf(value) !== -1
            }
        },
        tag: {
            type: String,
            default: 'oc-button-input'
        },
        options: {
            type: Object,
            default: () => ({})
        },
        submit: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'normal',
            validator: function (value) {
                return ['big', 'normal', 'small'].indexOf(value) !== -1
            }
        },
        icon: {
            type: [String, Boolean],
            default: false
        },
        iconAttrs: {
            type: Object,
            default: () => ({
                class: 'oc-button-icon-after'
            })
        },
        iconBefore: {
            type: [String, Boolean],
            default: false
        },
        iconBeforeAttrs: {
            type: Object,
            default: () => ({
                class: 'oc-button-icon-before'
            })
        }
    },
    computed: {
        $_iconAttrs() {
            let attrs = Object.assign({}, this.iconAttrs)

            if( this.text === undefined && attrs.class === 'oc-button-icon-after' ) {
                attrs.class = []
            }

            return attrs
        },
        attrs() {
            let attrs = Object.assign({}, this.$attrs, this.options)

            if( this.tag === 'a' && attrs.href === undefined ) {
                attrs.href = 'javascript:;'
            }

            return attrs
        },
        classes() {
            return [
                'btn',
                'btn-' + this.type,
                'btn-' + this.$_size,
                {
                    disabled: this.loading
                }
            ]
        },
        $_tag() {
            if( this.tag === 'oc-button-input' && this.submit ) {
                return 'oc-submit-button-input'
            }

            return this.tag
        },
        $_title() {
            if( this.attrs.title === undefined && this.text ) {
                return this.text
            }

            return this.attrs.title
        },
        $_size() {
            let sizes = {
                small: 'sm',
                normal: 'md',
                big: 'lg'
            }

            return sizes[this.size]
        }
    }
}
</script>

<style scoped>
.oc-button-icon-after {margin-left:1px;}
</style>
